export default "__VITE_ASSET__CYMSr2o4__"